import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Check } from 'lucide-react';
const tomos = [{
  num: 'T1',
  title: 'Mentalidad y Motivación',
  desc: 'La base que necesitas para dejar de abandonar.',
  checks: ['Cómo crear disciplina real', 'Eliminar bloqueos mentales', 'Mantener motivación sostenible']
}, {
  num: 'T2',
  title: 'Rutinas Desde Casa',
  desc: 'Entrenamientos simples y efectivos.',
  checks: ['Ejercicios para todos los niveles', 'Rutinas prácticas', 'Entrenamientos adaptables']
}, {
  num: 'T3',
  title: 'Hábitos Saludables',
  desc: 'Construye hábitos que realmente duren.',
  checks: ['Organización diaria', 'Constancia sin agotamiento', 'Hábitos sostenibles']
}, {
  num: 'T4',
  title: 'Alimentación Inteligente',
  desc: 'Mejora tu físico sin dietas extremas.',
  checks: ['Consejos simples de alimentación', 'Cómo mejorar tu energía', 'Relación saludable con la comida']
}, {
  num: 'T5',
  title: 'Energía y Bienestar',
  desc: 'Recupera tu equilibrio físico y mental.',
  checks: ['Más energía diaria', 'Mejor descanso', 'Menos estrés y ansiedad']
}, {
  num: 'T6',
  title: 'Transformación Completa',
  desc: 'Convierte esto en un estilo de vida.',
  checks: ['Cómo mantener resultados', 'Mentalidad de crecimiento', 'Evolución constante']
}];
export function TomosGrid() {
  return <section className="py-24 px-4 bg-dark" data-id="element-186">
      <div className="max-w-6xl mx-auto" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <h3 className="text-brand font-bold tracking-widest uppercase mb-4" data-id="element-189">
            TODO LO QUE INCLUYE
          </h3>
          <h2 className="text-5xl md:text-6xl font-display uppercase text-white mb-6" data-id="element-190">
            LOS 6 TOMOS
          </h2>
          <p className="text-xl text-gray-400" data-id="element-191">
            Tu hoja de ruta para transformar tu cuerpo y tu mente paso a paso
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-192">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-8 hover:border-brand/50 transition-colors group" data-id="element-193">
              <div className="flex items-center gap-4 mb-6" data-id="element-194">
                <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center text-brand font-display text-2xl" data-id="element-195">
                  {tomo.num}
                </div>
                <BookOpen className="w-6 h-6 text-gray-500 group-hover:text-brand transition-colors ml-auto" data-id="element-196" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-197">
                {tomo.title}
              </h3>
              <p className="text-gray-400 mb-6 h-12" data-id="element-198">{tomo.desc}</p>

              <div className="space-y-3" data-id="element-199">
                {tomo.checks.map((check, j) => <div key={j} className="flex items-start gap-3" data-id="element-200">
                    <Check className="w-5 h-5 text-brand shrink-0 mt-0.5" data-id="element-201" />
                    <span className="text-sm text-gray-300" data-id="element-202">{check}</span>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}